import * as React from 'react'
import {observer} from 'mobx-react'
import {EpmsPaymentInfoBlock} from './blocks/EpmsPaymentInfoBlock'

///////////////////////////////////////////////////////////////////////////////

export const EpmsPaymentInfoWidget = observer(() => {
  return (
    <div className="payment-widget">
      <EpmsPaymentInfoBlock />
    </div>
  )
})
